import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageKeys } from '../shared/enums/storage.enum';
import { StorageService } from '../services/storage/storage.service';


@Injectable({
    providedIn: 'root',
})
export class LoginGuard {
    constructor(public storageService: StorageService, public router: Router) { }

    canActivate(route: ActivatedRouteSnapshot):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {

        // If token comes in via query params (post-login redirect), store it first
        const paramToken = route.queryParams['token'];
        if (paramToken) {
            this.storageService.setDataToLocalStorage(StorageKeys.ACCESS_TOKEN, paramToken);
        }

        const token = this.storageService.getDataFromLocalStorage(StorageKeys.ACCESS_TOKEN);
        if (!token) {
            this.router.navigate(['login']);
            return false;
        }
        return true;
    }
}
